export default __webpack_public_path__ + "static/media/cirugia1.d304ddb0.jpg";